import { Button } from "@mui/material";

export default function SubmitButton(props) {
    return (
        <Button type="submit" {...props}>
            {props.children ? props.children : "Salvar"}
        </Button>
    );
}
